import type { AuditQuestion } from '@/lib/index';

export const auditQuestions: AuditQuestion[] = [
  // KATEGORIE 1: STRATEGIE (20 Fragen)
  {
    id: 'str-001',
    categoryId: 'strategie',
    text: 'Haben Sie ein klar definiertes ideales Kundenprofil?',
    tooltip: 'Ein ideales Kundenprofil (ICP) beschreibt den perfekten Kunden für Ihr Produkt: Branche, Unternehmensgröße, Budget, Entscheidungsträger, etc.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-002',
    categoryId: 'strategie',
    text: 'Ist Ihre Marktpositionierung eindeutig und differenziert?',
    tooltip: 'Positionierung bedeutet: Wie unterscheiden Sie sich von Wettbewerbern? Was macht Sie einzigartig?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-003',
    categoryId: 'strategie',
    text: 'Haben Sie Ihre Zielmärkte nach Priorität geordnet?',
    tooltip: 'Welche Märkte/Branchen bearbeiten Sie zuerst? Gibt es eine klare Priorisierung?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-004',
    categoryId: 'strategie',
    text: 'Kennen Sie die Schmerzpunkte Ihrer Zielkunden genau?',
    tooltip: 'Schmerzpunkte sind die größten Probleme und Herausforderungen, die Ihre Kunden haben und die Ihr Produkt löst.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-005',
    categoryId: 'strategie',
    text: 'Haben Sie eine dokumentierte Markteintrittsstrategie?',
    tooltip: 'Eine Markteintrittsstrategie beschreibt, wie Sie neue Märkte erschließen: Kanäle, Partner, Timing, Budget.',
    answerType: 'boolean',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-006',
    categoryId: 'strategie',
    text: 'Ist Ihr Wertversprechen klar formuliert?',
    tooltip: 'Das Wertversprechen erklärt in wenigen Sätzen, welchen konkreten Nutzen Kunden von Ihrem Produkt haben.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-007',
    categoryId: 'strategie',
    text: 'Haben Sie klare Umsatzziele für die nächsten 12 Monate?',
    tooltip: 'Konkrete, messbare Umsatzziele geben Ihrem Team Orientierung und ermöglichen die Erfolgsmessung.',
    answerType: 'boolean',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-008',
    categoryId: 'strategie',
    text: 'Kennen Sie Ihre wichtigsten Wettbewerber und deren Stärken/Schwächen?',
    tooltip: 'Wettbewerbsanalyse hilft Ihnen, sich besser zu positionieren und Ihre Vorteile klar herauszustellen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-009',
    categoryId: 'strategie',
    text: 'Haben Sie eine definierte Preisstrategie?',
    tooltip: 'Preisstrategie: Wie kalkulieren Sie Preise? Premium, Mittelfeld oder Discount? Gibt es Rabattstrukturen?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-010',
    categoryId: 'strategie',
    text: 'Ist Ihre Vertriebsstrategie schriftlich dokumentiert?',
    tooltip: 'Eine dokumentierte Strategie sorgt für Klarheit im Team und erleichtert die Umsetzung und Kontrolle.',
    answerType: 'boolean',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-011',
    categoryId: 'strategie',
    text: 'Haben Sie definierte Kundensegmente?',
    tooltip: 'Kundensegmente sind Gruppen von Kunden mit ähnlichen Bedürfnissen, z.B. nach Branche, Größe oder Anwendungsfall.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-012',
    categoryId: 'strategie',
    text: 'Kennen Sie Ihre durchschnittliche Kundenlebensdauer?',
    tooltip: 'Kundenlebensdauer (Customer Lifetime): Wie lange bleiben Kunden durchschnittlich bei Ihnen?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-013',
    categoryId: 'strategie',
    text: 'Haben Sie eine Strategie für Bestandskundenwachstum?',
    tooltip: 'Wie verkaufen Sie mehr an bestehende Kunden? Cross-Selling, Up-Selling, Zusatzprodukte?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-014',
    categoryId: 'strategie',
    text: 'Ist Ihr Alleinstellungsmerkmal klar kommuniziert?',
    tooltip: 'Alleinstellungsmerkmal (USP): Was können nur Sie? Was macht Sie einzigartig im Markt?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-015',
    categoryId: 'strategie',
    text: 'Haben Sie definierte Vertriebskanäle?',
    tooltip: 'Vertriebskanäle: Direktvertrieb, Partner, Online, Händler? Welche Kanäle nutzen Sie?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-016',
    categoryId: 'strategie',
    text: 'Kennen Sie Ihre Kundenakquisitionskosten?',
    tooltip: 'Kundenakquisitionskosten (CAC): Was kostet es Sie durchschnittlich, einen neuen Kunden zu gewinnen?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-017',
    categoryId: 'strategie',
    text: 'Haben Sie eine Strategie für internationale Märkte?',
    tooltip: 'Internationalisierung erfordert Planung: Welche Länder? Welche Anpassungen? Welche Partner?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-018',
    categoryId: 'strategie',
    text: 'Ist Ihre Zielgruppe klar definiert und dokumentiert?',
    tooltip: 'Eine klare Zielgruppendefinition verhindert Streuverluste und fokussiert Ihre Vertriebsressourcen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-019',
    categoryId: 'strategie',
    text: 'Haben Sie eine Strategie für Partnerschaften?',
    tooltip: 'Partnerschaften: Arbeiten Sie mit anderen Unternehmen zusammen? Gibt es eine Strategie dafür?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'str-020',
    categoryId: 'strategie',
    text: 'Wird Ihre Strategie regelmäßig überprüft und angepasst?',
    tooltip: 'Märkte ändern sich. Regelmäßige Strategie-Reviews (z.B. quartalsweise) halten Sie wettbewerbsfähig.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },

  // KATEGORIE 2: LEAD GENERATION (20 Fragen)
  {
    id: 'lead-001',
    categoryId: 'lead-generation',
    text: 'Haben Sie einen strukturierten Prozess für ausgehende Kundenansprache?',
    tooltip: 'Ausgehende Ansprache (Outbound): Kontaktieren Sie aktiv potenzielle Kunden per E-Mail, Telefon oder LinkedIn?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-002',
    categoryId: 'lead-generation',
    text: 'Nutzen Sie Marketing-Automatisierung für die Interessentengewinnung?',
    tooltip: 'Marketing-Automatisierung: Software, die automatisch E-Mails versendet, Leads bewertet und nachverfolgt.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-003',
    categoryId: 'lead-generation',
    text: 'Haben Sie definierte Interessentenquellen?',
    tooltip: 'Interessentenquellen: Woher kommen Ihre Leads? Website, Messen, Empfehlungen, Werbung, Partner?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-004',
    categoryId: 'lead-generation',
    text: 'Messen Sie die Qualität Ihrer Interessenten?',
    tooltip: 'Interessentenqualität: Wie gut passen Leads zu Ihrem idealen Kundenprofil? Werden sie bewertet?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-005',
    categoryId: 'lead-generation',
    text: 'Haben Sie einen Prozess zur Interessentenbewertung?',
    tooltip: 'Interessentenbewertung (Lead Scoring): System zur Bewertung von Leads nach Kaufbereitschaft und Passung.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-006',
    categoryId: 'lead-generation',
    text: 'Nutzen Sie Content-Marketing zur Interessentengewinnung?',
    tooltip: 'Content-Marketing: Blogartikel, Whitepapers, Videos, die potenzielle Kunden anziehen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-007',
    categoryId: 'lead-generation',
    text: 'Haben Sie einen definierten Verkaufstrichter?',
    tooltip: 'Verkaufstrichter (Sales Funnel): Die Phasen, die ein Interessent durchläuft bis zum Kauf.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-008',
    categoryId: 'lead-generation',
    text: 'Messen Sie Ihre Konversionsraten in jeder Phase?',
    tooltip: 'Konversionsrate: Wie viel Prozent der Interessenten gehen von einer Phase zur nächsten?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-009',
    categoryId: 'lead-generation',
    text: 'Nutzen Sie soziale Medien aktiv für die Kundengewinnung?',
    tooltip: 'Social Selling: LinkedIn, XING, Facebook, Instagram für Kundengewinnung nutzen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-010',
    categoryId: 'lead-generation',
    text: 'Haben Sie ein Empfehlungsprogramm?',
    tooltip: 'Empfehlungsprogramm: Belohnen Sie Kunden, die neue Kunden empfehlen?',
    answerType: 'boolean',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-011',
    categoryId: 'lead-generation',
    text: 'Nutzen Sie bezahlte Werbung zur Interessentengewinnung?',
    tooltip: 'Bezahlte Werbung: Google Ads, LinkedIn Ads, Facebook Ads, etc.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-012',
    categoryId: 'lead-generation',
    text: 'Haben Sie Landing Pages für verschiedene Zielgruppen?',
    tooltip: 'Landing Pages: Spezielle Webseiten für bestimmte Kampagnen oder Zielgruppen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-013',
    categoryId: 'lead-generation',
    text: 'Nutzen Sie E-Mail-Marketing systematisch?',
    tooltip: 'Regelmäßige, zielgerichtete E-Mail-Kampagnen halten Interessenten warm und führen zu Abschlüssen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-014',
    categoryId: 'lead-generation',
    text: 'Haben Sie einen Prozess für Interessentenpflege?',
    tooltip: 'Interessentenpflege (Lead Nurturing): Regelmäßiger Kontakt zu Leads, die noch nicht kaufbereit sind.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-015',
    categoryId: 'lead-generation',
    text: 'Messen Sie die Kosten pro Interessent?',
    tooltip: 'Kosten pro Lead: Was kostet es Sie, einen qualifizierten Interessenten zu generieren?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-016',
    categoryId: 'lead-generation',
    text: 'Nutzen Sie Webinare oder Events zur Interessentengewinnung?',
    tooltip: 'Webinare und Events ermöglichen direkten Kontakt und positionieren Sie als Experte.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-017',
    categoryId: 'lead-generation',
    text: 'Haben Sie einen Prozess für Kaltakquise?',
    tooltip: 'Kaltakquise: Erstkontakt zu potenziellen Kunden, die Sie noch nicht kennen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-018',
    categoryId: 'lead-generation',
    text: 'Nutzen Sie Suchmaschinenoptimierung aktiv?',
    tooltip: 'Suchmaschinenoptimierung (SEO): Optimierung Ihrer Website für Google & Co.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-019',
    categoryId: 'lead-generation',
    text: 'Haben Sie einen Prozess für Messebesuche und Events?',
    tooltip: 'Strukturierte Vor- und Nachbereitung von Messen maximiert den ROI und generiert qualifizierte Leads.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'lead-020',
    categoryId: 'lead-generation',
    text: 'Wird die Qualität Ihrer Interessentenquellen regelmäßig analysiert?',
    tooltip: 'Welche Kanäle liefern die besten Leads? Regelmäßige Analyse optimiert Ihr Marketing-Budget.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },

  // KATEGORIE 3: SALES PROZESS (20 Fragen)
  {
    id: 'proc-001',
    categoryId: 'sales-prozess',
    text: 'Haben Sie definierte Verkaufsphasen?',
    tooltip: 'Verkaufsphasen: Erstkontakt, Bedarfsanalyse, Angebot, Verhandlung, Abschluss - sind diese klar definiert?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-002',
    categoryId: 'sales-prozess',
    text: 'Kennen Sie Ihre Konversionsraten zwischen den Phasen?',
    tooltip: 'Wie viele Interessenten gehen von Phase zu Phase? Z.B. 50% von Erstgespräch zu Angebot.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-003',
    categoryId: 'sales-prozess',
    text: 'Haben Sie einen strukturierten Qualifizierungsprozess?',
    tooltip: 'Qualifizierung: Wie entscheiden Sie, ob ein Interessent ein guter potenzieller Kunde ist?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-004',
    categoryId: 'sales-prozess',
    text: 'Ist Ihr Verkaufsprozess dokumentiert?',
    tooltip: 'Ein dokumentierter Prozess sorgt für Konsistenz, erleichtert Schulungen und ermöglicht Optimierung.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-005',
    categoryId: 'sales-prozess',
    text: 'Nutzen Sie ein standardisiertes Bedarfsanalysegespräch?',
    tooltip: 'Bedarfsanalyse: Strukturiertes Gespräch, um die Bedürfnisse des Kunden zu verstehen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-006',
    categoryId: 'sales-prozess',
    text: 'Haben Sie Vorlagen für Angebote und Präsentationen?',
    tooltip: 'Professionelle Vorlagen sparen Zeit, sorgen für einheitliches Auftreten und erhöhen die Abschlussquote.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-007',
    categoryId: 'sales-prozess',
    text: 'Messen Sie Ihre durchschnittliche Verkaufszyklusdauer?',
    tooltip: 'Verkaufszyklus: Wie lange dauert es vom Erstkontakt bis zum Abschluss?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-008',
    categoryId: 'sales-prozess',
    text: 'Haben Sie einen definierten Nachfassprozess?',
    tooltip: 'Nachfassen: Wie oft und wann kontaktieren Sie Interessenten nach dem ersten Gespräch?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-009',
    categoryId: 'sales-prozess',
    text: 'Nutzen Sie eine strukturierte Verkaufsmethodik?',
    tooltip: 'Verkaufsmethodik: Z.B. SPIN Selling, Challenger Sale, Solution Selling - ein systematischer Ansatz.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-010',
    categoryId: 'sales-prozess',
    text: 'Haben Sie klare Kriterien für Geschäftsabschlüsse?',
    tooltip: 'Wann ist ein Deal gewonnen? Welche Bedingungen müssen erfüllt sein?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-011',
    categoryId: 'sales-prozess',
    text: 'Führen Sie regelmäßige Verkaufsprognosen durch?',
    tooltip: 'Verkaufsprognose (Forecast): Vorhersage, welche Deals wann abgeschlossen werden.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-012',
    categoryId: 'sales-prozess',
    text: 'Haben Sie einen Prozess für Einwandbehandlung?',
    tooltip: 'Einwandbehandlung: Wie gehen Sie mit "zu teuer", "kein Budget", "kein Bedarf" um?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-013',
    categoryId: 'sales-prozess',
    text: 'Nutzen Sie Verkaufsskripte oder Gesprächsleitfäden?',
    tooltip: 'Leitfäden helfen, wichtige Punkte im Verkaufsgespräch nicht zu vergessen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-014',
    categoryId: 'sales-prozess',
    text: 'Haben Sie einen Prozess für Vertragsverhandlungen?',
    tooltip: 'Strukturierte Verhandlungen mit klaren Spielräumen und Eskalationswegen sichern profitable Abschlüsse.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-015',
    categoryId: 'sales-prozess',
    text: 'Messen Sie Ihre Abschlussquote?',
    tooltip: 'Abschlussquote (Win Rate): Wie viel Prozent Ihrer Angebote werden zu Aufträgen?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-016',
    categoryId: 'sales-prozess',
    text: 'Haben Sie einen Prozess für verlorene Geschäfte?',
    tooltip: 'Was passiert mit Deals, die Sie verloren haben? Gibt es eine Nachverfolgung?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-017',
    categoryId: 'sales-prozess',
    text: 'Nutzen Sie Referenzkunden aktiv im Verkaufsprozess?',
    tooltip: 'Referenzkunden: Zufriedene Kunden, die Sie als Beispiel nennen können.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-018',
    categoryId: 'sales-prozess',
    text: 'Haben Sie einen Prozess für Produktdemonstrationen?',
    tooltip: 'Strukturierte Demos mit klarem Ablauf und Fokus auf Kundennutzen erhöhen die Abschlusswahrscheinlichkeit.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-019',
    categoryId: 'sales-prozess',
    text: 'Wird Ihr Verkaufsprozess regelmäßig optimiert?',
    tooltip: 'Kontinuierliche Prozessverbesserung basierend auf Daten und Feedback steigert die Effizienz.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'proc-020',
    categoryId: 'sales-prozess',
    text: 'Haben Sie einen Übergabeprozess an den Kundendienst?',
    tooltip: 'Was passiert nach dem Verkauf? Wie wird der Kunde an Service/Support übergeben?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },

  // KATEGORIE 4: TOOLS & AUTOMATISIERUNG (20 Fragen)
  {
    id: 'tool-001',
    categoryId: 'tools',
    text: 'Nutzen Sie ein Kundenbeziehungssystem?',
    tooltip: 'Kundenbeziehungssystem (CRM): Software wie Salesforce, HubSpot, Pipedrive zur Verwaltung von Kundenkontakten.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-002',
    categoryId: 'tools',
    text: 'Ist die Datenqualität in Ihrem System hoch?',
    tooltip: 'Sind Kundendaten vollständig, aktuell und korrekt?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-003',
    categoryId: 'tools',
    text: 'Nutzen Sie Marketing-Automatisierung?',
    tooltip: 'Tools wie HubSpot, Marketo, ActiveCampaign für automatisierte E-Mail-Kampagnen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-004',
    categoryId: 'tools',
    text: 'Haben Sie automatisierte Arbeitsabläufe eingerichtet?',
    tooltip: 'Workflows: Automatische Aufgaben, E-Mails oder Benachrichtigungen bei bestimmten Ereignissen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-005',
    categoryId: 'tools',
    text: 'Nutzen Sie Verkaufsanalyse-Tools?',
    tooltip: 'Tools zur Analyse von Verkaufsdaten, Dashboards, Berichte.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-006',
    categoryId: 'tools',
    text: 'Haben Sie ein System zur Angebotserstellung?',
    tooltip: 'Software zur schnellen Erstellung professioneller Angebote.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-007',
    categoryId: 'tools',
    text: 'Nutzen Sie Tools für Videokonferenzen und Demos?',
    tooltip: 'Zoom, Teams, Google Meet für Online-Meetings und Produktpräsentationen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-008',
    categoryId: 'tools',
    text: 'Haben Sie ein System für E-Mail-Nachverfolgung?',
    tooltip: 'Tracking: Sehen Sie, ob und wann Ihre E-Mails geöffnet wurden?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-009',
    categoryId: 'tools',
    text: 'Nutzen Sie Tools zur Terminvereinbarung?',
    tooltip: 'Calendly, Doodle, etc. - Tools, mit denen Kunden selbst Termine buchen können.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-010',
    categoryId: 'tools',
    text: 'Haben Sie ein System für Kundenfeedback?',
    tooltip: 'Wie sammeln Sie systematisch Feedback von Kunden?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-011',
    categoryId: 'tools',
    text: 'Nutzen Sie Tools für soziale Medien?',
    tooltip: 'LinkedIn Sales Navigator, Hootsuite, Buffer für Social Selling.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-012',
    categoryId: 'tools',
    text: 'Haben Sie ein System für Dokumentenverwaltung?',
    tooltip: 'Wo speichern Sie Verträge, Angebote, Präsentationen? Ist es organisiert?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-013',
    categoryId: 'tools',
    text: 'Nutzen Sie Tools für Verkaufsschulungen?',
    tooltip: 'E-Learning-Plattformen, Video-Training für Ihr Verkaufsteam.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-014',
    categoryId: 'tools',
    text: 'Haben Sie ein System für Leistungskennzahlen?',
    tooltip: 'Dashboards mit wichtigen Verkaufskennzahlen (KPIs) in Echtzeit.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-015',
    categoryId: 'tools',
    text: 'Nutzen Sie künstliche Intelligenz im Vertrieb?',
    tooltip: 'KI für Lead-Bewertung, Verkaufsprognosen oder Chatbots.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-016',
    categoryId: 'tools',
    text: 'Haben Sie mobile Zugriffsmöglichkeiten auf Ihre Systeme?',
    tooltip: 'Können Verkäufer von unterwegs auf CRM und andere Tools zugreifen?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-017',
    categoryId: 'tools',
    text: 'Nutzen Sie Tools zur Wettbewerbsbeobachtung?',
    tooltip: 'Software, die Wettbewerber-Websites, Preise oder Aktivitäten überwacht.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-018',
    categoryId: 'tools',
    text: 'Haben Sie Schnittstellen zwischen Ihren Systemen?',
    tooltip: 'Sind CRM, E-Mail, Marketing-Tools miteinander verbunden?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-019',
    categoryId: 'tools',
    text: 'Nutzen Sie Tools für Verkaufsprognosen?',
    tooltip: 'Software, die basierend auf Daten vorhersagt, welche Deals abgeschlossen werden.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'tool-020',
    categoryId: 'tools',
    text: 'Werden Ihre Tools regelmäßig aktualisiert und optimiert?',
    tooltip: 'Regelmäßige Updates und Optimierungen halten Ihre Tools effizient und sicher.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },

  // KATEGORIE 5: TEAM & ORGANISATION (20 Fragen)
  {
    id: 'team-001',
    categoryId: 'organisation',
    text: 'Haben Sie klar definierte Verkaufsrollen?',
    tooltip: 'Sind Aufgaben klar verteilt? Z.B. Neukundenakquise, Bestandskundenbetreuung, Innendienst.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-002',
    categoryId: 'organisation',
    text: 'Gibt es regelmäßige Verkaufsschulungen?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-003',
    categoryId: 'organisation',
    text: 'Haben Sie ein strukturiertes Einarbeitungsprogramm?',
    tooltip: 'Onboarding: Wie werden neue Verkäufer eingearbeitet? Gibt es einen Plan?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-004',
    categoryId: 'organisation',
    text: 'Nutzen Sie ein leistungsbasiertes Vergütungssystem?',
    tooltip: 'Provisionen, Boni - werden Verkäufer nach Leistung bezahlt?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-005',
    categoryId: 'organisation',
    text: 'Haben Sie klare Verkaufsziele für jeden Mitarbeiter?',
    tooltip: 'Individuelle, messbare Ziele geben Orientierung und ermöglichen faire Leistungsbewertung.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-006',
    categoryId: 'organisation',
    text: 'Führen Sie regelmäßige Leistungsgespräche?',
    tooltip: 'Einzelgespräche zur Besprechung von Zielen, Fortschritt und Entwicklung.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-007',
    categoryId: 'organisation',
    text: 'Gibt es regelmäßige Verkaufsbesprechungen?',
    tooltip: 'Team-Meetings zur Besprechung von Deals, Strategien und Herausforderungen.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-008',
    categoryId: 'organisation',
    text: 'Haben Sie einen Prozess für Wissensaustausch im Team?',
    tooltip: 'Wie teilen Verkäufer Best Practices und Erfahrungen untereinander?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-009',
    categoryId: 'organisation',
    text: 'Nutzen Sie Verkaufscoaching?',
    tooltip: 'Individuelle Begleitung und Entwicklung von Verkäufern durch erfahrene Coaches.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-010',
    categoryId: 'organisation',
    text: 'Haben Sie definierte Karrierepfade im Vertrieb?',
    tooltip: 'Können Verkäufer aufsteigen? Gibt es klare Entwicklungsmöglichkeiten?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-011',
    categoryId: 'organisation',
    text: 'Messen Sie die Mitarbeiterzufriedenheit im Vertrieb?',
    tooltip: 'Zufriedene Mitarbeiter sind produktiver und bleiben länger. Regelmäßige Umfragen zeigen Handlungsbedarf.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-012',
    categoryId: 'organisation',
    text: 'Haben Sie einen Prozess für Mitarbeitergewinnung?',
    tooltip: 'Recruiting: Wie finden und gewinnen Sie gute Verkäufer?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-013',
    categoryId: 'organisation',
    text: 'Gibt es eine Verkaufskultur in Ihrem Unternehmen?',
    tooltip: 'Wird Vertrieb wertgeschätzt? Gibt es eine positive Einstellung zum Verkaufen?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-014',
    categoryId: 'organisation',
    text: 'Haben Sie Prozesse zur Konfliktlösung im Team?',
    tooltip: 'Klare Konfliktlösungsmechanismen verhindern Eskalation und erhalten ein positives Arbeitsklima.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-015',
    categoryId: 'organisation',
    text: 'Nutzen Sie Teambuilding-Maßnahmen?',
    tooltip: 'Events, Workshops oder Aktivitäten zur Stärkung des Teamzusammenhalts.',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-016',
    categoryId: 'organisation',
    text: 'Haben Sie einen Prozess für Leistungsbeurteilung?',
    tooltip: 'Wie bewerten Sie die Leistung Ihrer Verkäufer? Gibt es klare Kriterien?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-017',
    categoryId: 'organisation',
    text: 'Gibt es Anerkennung und Belohnungen für gute Leistungen?',
    tooltip: 'Werden Top-Performer gefeiert? Gibt es Anreize und Wertschätzung?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-018',
    categoryId: 'organisation',
    text: 'Haben Sie eine Strategie zur Mitarbeiterbindung?',
    tooltip: 'Wie halten Sie gute Verkäufer im Unternehmen?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-019',
    categoryId: 'organisation',
    text: 'Gibt es Zusammenarbeit zwischen Vertrieb und Marketing?',
    tooltip: 'Arbeiten beide Abteilungen gut zusammen? Gibt es regelmäßigen Austausch?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
  {
    id: 'team-020',
    categoryId: 'organisation',
    text: 'Haben Sie einen Prozess für kontinuierliche Verbesserung?',
    tooltip: 'Wird der Vertrieb regelmäßig analysiert und optimiert?',
    answerType: 'scale',
    weight: 1,
    maxScore: 5,
  },
];
